import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, Card, CardTitle } from 'material-ui';

const TableArrayField = ({ record, choices, property, populate, source, style, label }) => {
  const table = (
    <Table>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          {property.headers.map((header) => <TableHeaderColumn key={header}>{header}</TableHeaderColumn>)}
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        { populate &&
            choices[source].filter((choice) => record[populate].includes(choice._id)).map((item) => (
              <TableRow key={`row-${item._id}`}>
                {property.keys.map((key) => <TableRowColumn key={item._id}>{item[key]}</TableRowColumn>)}
              </TableRow>
            ))
        }
      </TableBody>

    </Table>
  );
  return (
    <Card style={{ ...style, marginTop: '0.5em' }}>
      <CardTitle subtitle={label} />
      {
        table
      }
    </Card>
  );
};

TableArrayField.propTypes = {
  addLabel: PropTypes.bool, // eslint-disable-line
  choices: PropTypes.object,
  label: PropTypes.string, // eslint-disable-line
  populate: PropTypes.string,
  property: PropTypes.object.isRequired,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  style: PropTypes.object,
};
const PureTableArrayField = pure(TableArrayField);

TableArrayField.defaultProps = {
  addLabel: true,
};


export default PureTableArrayField;
